import { useCallback, useEffect, useState } from 'react';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import { ContentDisplayTiles, UHCalenderComp } from 'src/components';
import RazorpayTable from './RazorpayTable';
import { API_SERVICES } from 'src/Services';
import { HTTP_STATUSES } from 'src/Config/constant';
import { useEdit } from 'src/hooks/useEdit';
import { useSearchVal } from 'src/hooks/useSearchVal';
import { useDebounce } from 'src/hooks/useDebounce';
import RazorpayXTable from './RazorpayXTable';
import { getTimestampFromDate } from 'src/Utils';
import AdminCommissionTable from './AdminCommissionTable';
import ValidationDebitTable from './ValidationDebitTable';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(1)
    },
    titleStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    contentBoxStyles: {
      padding: theme.spacing(3, 0, 4, 0)
    },
    currentBalanceBoxStyles: {
      display: 'flex',
      //alignItems: 'center',
      justifyContent: 'flex-end'
      //height: '100%'
    },
    currentBalanceContentBoxStyles: {
      display: 'flex',
      border: '1px solid black',
      borderRadius: '2px',
      padding: theme.spacing(1.2),
      gap: theme.spacing(3)
    },
    currentBalanceTextStyles: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      color: theme.Colors.primary,
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.MetricsSizes.small_x
    }
  };
});

const AdminWallet = () => {
  const classes = useStyles();
  const [razorpayData, setRazorpayData] = useState<any[]>([]);
  const [currentBalanceData, setCurrentBalanceData] = useState<any>({});
  const [razorpayXData, setRazorpayXData] = useState<any[]>([]);
  const [adminCommission, setAdminCommission] = useState<any[]>([]);
  const [bankValidation, setBankValidation] = useState<any[]>([]);
  const adminWalletTabValues = [
    {
      heading: 'Credit',
      subText: razorpayData?.length,
      // iconImage: RupeeIcon,
      value: 1,
      right: `₹${currentBalanceData?.totalCreditAmount}`
    },
    {
      heading: 'Debit ',
      subText: razorpayXData?.length,
      // iconImage: RupeeIcon,
      value: 2,
      right: `₹${currentBalanceData?.totalDebitAmount}`
    },
    {
      heading: 'Commission ',
      subText: adminCommission?.length,
      // iconImage: RupeeIcon,
      value: 3,
      right: `₹${
        currentBalanceData?.totalCommission
          ? parseFloat(currentBalanceData.totalCommission).toFixed(2)
          : '0.00'
      }`
    },
    {
      heading: 'Validation Debit',
      subText: bankValidation?.length,
      // iconImage: RupeeIcon,
      value: 4,
      right: `₹${currentBalanceData?.totalValidationAmount}`
    }
  ];

  const initialValue = {
    search: '',
    date: ''
  };
  const edit = useEdit(initialValue);
  const [selectedTab, setSelectedTab] = useState<string | number>(
    adminWalletTabValues[0].value
  );
  const [dateSelect, setDateSelect] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const [calendarOpen, setCalendarOpen] = useState<any>({ open: false });
  const { searchValue } = useSearchVal();
  const debValue = useDebounce(searchValue, 2000);

  const handleSetSelectedTab = (value) => {
    setSelectedTab(value);
    edit.update({ date: '', search: '' });
  };

  const fetchData = useCallback(async () => {
    try {
      setRazorpayData([]);
      setRazorpayXData([]);
      setAdminCommission([]);
      let params: any = {};
      if (debValue !== '') {
        params.searchString = debValue;
      }
      const searchData = {
        searchString: edit.getValue('search'),
        toDate: edit.getValue('date').split('to')[1],
        fromDate: edit.getValue('date').split('to')[0],
        ...params
      };
      const response: any = await Promise.all([
        API_SERVICES.AdminWalletService.getAllRazorpayTransaction(
          selectedTab == 1 &&
            edit.getValue('search') == '' &&
            edit.getValue('date') == ''
            ? params
            : selectedTab == 1
            ? searchData
            : ''
        ),
        API_SERVICES.AdminWalletService.getCurrentBalance(),
        API_SERVICES.AdminWalletService.getAllRazorpayXTransaction(
          selectedTab == 2 &&
            edit.getValue('search') == '' &&
            edit.getValue('date') == ''
            ? params
            : selectedTab == 2
            ? searchData
            : ''
        ),
        API_SERVICES.AdminWalletService.getAllCommissionTransaction(
          selectedTab == 3 &&
            edit.getValue('search') == '' &&
            edit.getValue('date') == ''
            ? params
            : selectedTab == 3
            ? searchData
            : ''
        ),
        API_SERVICES.AdminWalletService.getAllBankValidationTransactions(
          selectedTab == 4 &&
            edit.getValue('search') == '' &&
            edit.getValue('date') == ''
            ? params
            : selectedTab == 4
            ? searchData
            : ''
        )
      ]);
      if (response[0]?.status < HTTP_STATUSES.BAD_REQUEST) {
        if (response[0]?.data?.data?.length) {
          setRazorpayData(response[0]?.data?.data);
        }
      }
      console.log(response[1]?.data?.totals, 'response[1]?.data?.data');
      if (response[1]?.data?.totals) {
        setCurrentBalanceData(response[1]?.data?.totals);
      }
      console.log(response[2]?.data?.data, 'response[2]?.data?.data');
      if (response[2]?.data?.data) {
        setRazorpayXData(response[2]?.data?.data);
      }
      if (response[3]?.data?.data) {
        setAdminCommission(response[3]?.data?.data);
      }
      if (response[4]?.data?.data) {
        setBankValidation(response[4]?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [edit.edits, debValue]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChange = useCallback(
    (item) => {
      setDateSelect([item.selection]);

      // If startDate equals endDate and they're the same as the current date,
      // the user might have cleared the selection
      const today = new Date();
      const startDate = item.selection.startDate;
      const endDate = item.selection.endDate;

      if (
        startDate.getDate() === today.getDate() &&
        startDate.getMonth() === today.getMonth() &&
        startDate.getFullYear() === today.getFullYear() &&
        endDate.getDate() === today.getDate() &&
        endDate.getMonth() === today.getMonth() &&
        endDate.getFullYear() === today.getFullYear()
      ) {
        // This is likely a reset to today's date, which might indicate clearing
        edit.update({ date: '' });
      }
    },
    [dateSelect]
  );

  const handleClick = () => {
    const fromDate = dateSelect[0].startDate
      .toLocaleDateString('en-US')
      ?.split('/');
    const toDate = dateSelect[0].endDate
      .toLocaleDateString('en-US')
      ?.split('/');
    // let new =
    console.log(
      dateSelect[0].startDate,
      `${fromDate[1]}/${fromDate[0]}/${fromDate[2]}`,
      '<-------'
    );

    edit.update({
      date: `${fromDate[1]}/${fromDate[0]}/${fromDate[2]} to ${toDate[1]}/${toDate[0]}/${toDate[2]}`
    });
    setCalendarOpen({ open: false });
  };
  const handleOpenCalendar = () => {
    setCalendarOpen({ open: true });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <ContentDisplayTiles
            displayContent={adminWalletTabValues}
            isTileTypeOrders={true}
            onTabChange={handleSetSelectedTab}
            tabValue={selectedTab}
          />
        </Grid>
        {/* <Grid item xs={3} style={{ paddingTop: 20 }}>
          <Box className={classes.currentBalanceBoxStyles}>
            <Box className={classes.currentBalanceContentBoxStyles}>
              <Box className={classes.currentBalanceTextStyles}>
                <WalletManagement /> <span>Total Amount</span>
              </Box>
              <Box className={classes.currentBalanceTextStyles}>
                {selectedTab == 1
                  ? currentBalanceData?.razorpayBalance
                  : selectedTab == 2
                  ? currentBalanceData?.razorpayXBalance
                  : currentBalanceData?.commissionBalance}
              </Box>
            </Box>
          </Box>
        </Grid> */}
      </Grid>
      {selectedTab == 1 ? (
        <RazorpayTable
          selectedTab={selectedTab}
          tableData={razorpayData}
          edit={edit}
          handleOpenCalendar={handleOpenCalendar}
          currentBalance={currentBalanceData}
        />
      ) : null}
      {selectedTab == 2 ? (
        <RazorpayXTable
          tableData={razorpayXData}
          edit={edit}
          handleOpenCalendar={handleOpenCalendar}
          currentBalance={currentBalanceData}
        />
      ) : null}
      {selectedTab == 3 ? (
        <AdminCommissionTable
          selectedTab={selectedTab}
          tableData={adminCommission}
          edit={edit}
          handleOpenCalendar={handleOpenCalendar}
          currentBalance={currentBalanceData}
        />
      ) : null}
      {selectedTab == 4 ? (
        <ValidationDebitTable
          selectedTab={selectedTab}
          tableData={bankValidation}
          edit={edit}
          handleOpenCalendar={handleOpenCalendar}
          currentBalance={currentBalanceData}
        />
      ) : null}
      {calendarOpen.open ? (
        <UHCalenderComp
          onCancelClick={() => {
            // When cancel is clicked, reset everything
            setCalendarOpen({ open: false });
            edit.update({ date: '' });
            // Reset the date selection to today (default state)
            setDateSelect([
              {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
              }
            ]);
          }}
          handleChange={handleChange}
          ranges={dateSelect}
          onConfirmClick={handleClick}
          {...calendarOpen}
        />
      ) : null}
    </>
  );
};

export default AdminWallet;
